import React from 'react'
import Select from 'react-select'
import {ISelectOption} from '../core/_model'

interface SecondarySelectBoxProps {
  options: ISelectOption[]
  placeholder?: string
  value?: ISelectOption | null
  onChange?: (selectedId: number | string | null, option?: ISelectOption | null) => void
  isClearable?: boolean
  isDisabled?: boolean
  className?: string
  isRequired?: boolean
}

const SecondarySelectBox: React.FC<SecondarySelectBoxProps> = ({
  options,
  placeholder = 'Select...',
  value,
  onChange,
  isClearable = true,
  isDisabled = false,
  className = '',
  isRequired = false,
}) => {
  const handleChange = (selected: ISelectOption | null) => {
    onChange?.(selected ? selected.id : null, selected)
  }

  return (
    <Select
      className={`react-select-styled custom-input ${className}`}
      classNamePrefix='react-select'
      options={options}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      isClearable={isClearable}
      isDisabled={isDisabled}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.value.toString()}
      required={isRequired}
    />
  )
}

export default SecondarySelectBox
